import axios from 'axios'

export const PAIPAN_TIME_ERROR_MESSAGE = '当前时间异常，请尝试其它时间'

const BLACK_YEAR_API = 'https://bzapi2.iwzbz.com/getblackyear.php'
const BUILT_IN_RESTRICTED_MONTHS = ['1953-06']

export class PaipanTimeLimit {
  constructor() {
    this.restrictedMonths = new Set(BUILT_IN_RESTRICTED_MONTHS)
    this.loadingPromise = null
  }

  normalizeMonth(value) {
    if (Array.isArray(value)) {
      const [year, month] = value
      return this.normalizeMonth(`${year}-${month}`)
    }

    const match = String(value || '').match(/^(\d{4})[-/](\d{1,2})/)
    if (!match) return ''

    return `${match[1]}-${match[2].padStart(2, '0')}`
  }

  addRestrictedMonths(months) {
    if (!Array.isArray(months)) return

    months.forEach((month) => {
      const normalizedMonth = this.normalizeMonth(month)
      if (normalizedMonth) this.restrictedMonths.add(normalizedMonth)
    })
  }

  async init() {
    if (!this.loadingPromise) {
      this.loadingPromise = axios
        .get(BLACK_YEAR_API)
        .then((response) => {
          const months = Array.isArray(response) ? response : response?.data
          this.addRestrictedMonths(months)
        })
        .catch(() => undefined)
    }

    return this.loadingPromise
  }

  isRestricted(value) {
    return this.restrictedMonths.has(this.normalizeMonth(value))
  }
}

const paipanTimeLimit = new PaipanTimeLimit()

export const initPaipanTimeLimit = () => paipanTimeLimit.init()
export const isPaipanTimeRestricted = (value) =>
  paipanTimeLimit.isRestricted(value)

export default paipanTimeLimit
